import { Box, Typography } from '@mui/material'
import { getImageUrl } from '../utils/getImageUrl'

const SheInspireCard = ({ item }) => {
    const { imageUrl, heading, text, date } = item
    return (
        <Box
            sx={{
                position: "relative",
                backgroundImage: `linear-gradient(180deg, rgba(0, 0, 0, 0) 36.21%, #000000 100%), url(${getImageUrl(imageUrl)})`,
                backgroundSize: "cover",
                backgroundPosition: "bottom",
                backgroundRepeat: "no-repeat",
                borderRadius: "40px",
                overflow: "hidden",
                minHeight: "350px",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "end",
                p: "20px",
                gap: 2

            }}>

            <Typography variant='body1' color='#fff' dangerouslySetInnerHTML={{ __html: heading }} />
            {/* >{heading}</Typography> */}
            <Typography variant='body2' color='#fff'   fontWeight={200} textAlign={"center"} dangerouslySetInnerHTML={{ __html: text }} />
            {/* >{text}</Typography> */}
            <Typography variant='body2' color='#fff'   fontWeight={200} textAlign={"center"} dangerouslySetInnerHTML={{ __html: date }} />
            {/* >24th may 2025</Typography> */}
        </Box>
    )
}

export default SheInspireCard